import type { TOC } from '@ember/component/template-only';

import DataManagerConnectionsComponent from 'webapp/components/data-manager/connections';

const DatamanagerConnectionsRouteTemplate: TOC<object> = <template>
	<DataManagerConnectionsComponent />
</template>;

export default DatamanagerConnectionsRouteTemplate;
